import approvalGif from "../../../assets/images/approved.gif";
import storedGif from "../../../assets/images/locker.gif";
import upcomingGif from "../../../assets/images/upcoming.gif";
import memberGif from "../../../assets/images/family.gif";
import approved from "../../../assets/images/verify.png";
import stored from "../../../assets/images/STORE.png";
import upcome from "../../../assets/images/upcome.png";
import fam from "../../../assets/images/fam.png";

export const pickuptabs = [
  { name: "Approval", gif: approvalGif, still: approved },
  { name: "Stored", gif: storedGif, still: stored },
  { name: "Upcoming", gif: upcomingGif, still: upcome },
  { name: "Members", gif: memberGif, still: fam },
];
